import React from "react";
import { MessageCircle, Phone, User, Newspaper } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function BottomNav({ tab, setTab, badges = {} }) {
  const { t } = useI18n();
  const items = [
    { key: "chats", icon: MessageCircle, label: t("tab_chats") },
    { key: "social", icon: Newspaper, label: t("tab_social") },
    { key: "calls", icon: Phone, label: t("tab_calls") },
    { key: "settings", icon: User, label: t("tab_settings") },
  ];
  return (
    <nav className="rc-safe-bottom border-t border-[var(--rc-border)] bg-[var(--rc-bg)] flex items-stretch" data-testid="bottom-nav">
      {items.map((it) => {
        const active = tab === it.key;
        const badge = badges[it.key] || 0;
        return (
          <button key={it.key} onClick={() => { if (it.soon) return; setTab(it.key); }} disabled={it.soon} data-testid={`nav-${it.key}`}
            className={`relative flex-1 flex flex-col items-center gap-1 py-2.5 transition-colors ${it.soon ? "text-[var(--rc-muted)] opacity-60 cursor-not-allowed" : active ? "text-[var(--rc-gold)]" : "text-[var(--rc-muted)]"}`}>
            <div className="relative">
              <it.icon size={22} strokeWidth={active ? 2.2 : 1.7} />
              {it.soon && <span data-testid={`nav-soon-${it.key}`} className="absolute -top-2 left-1/2 -translate-x-1/2 rotate-6 whitespace-nowrap rounded-full bg-[var(--rc-gold)] text-black text-[8px] font-extrabold px-1.5 py-0.5 shadow leading-none">{t("coming_soon")}</span>}
              {badge > 0 && <span data-testid={`nav-badge-${it.key}`} className="absolute -top-1.5 -right-2 h-4 min-w-4 px-1 grid place-items-center rounded-full bg-[var(--rc-gold)] text-black text-[10px] font-bold">{badge > 9 ? "9+" : badge}</span>}
            </div>
            <span className={`text-[11px] ${active && !it.soon ? "font-semibold" : ""}`}>{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
